"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedField = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
let LocalizedField = class LocalizedField {
    en = "";
    de = "";
    es = "";
    pt = "";
    cs = "";
    sv = "";
    zh = "";
    ko = "";
    fr = "";
    hi = "";
};
exports.LocalizedField = LocalizedField;
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "en", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "de", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "es", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "pt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "cs", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "sv", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "zh", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "ko", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "fr", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "hi", void 0);
exports.LocalizedField = LocalizedField = __decorate([
    (0, type_graphql_1.ObjectType)("LocalizedField")
], LocalizedField);
//# sourceMappingURL=LocalizedField.js.map